/* eslint-disable no-unused-vars */
import Logo from '../../assets/images/icons/logo192.png';

/**
 * comprueba si los sw y notificaciones push son compatibles con su navegador
 */
function isPushNotificationSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

/**
 *solicita el consentimiento del usuario para recibir notificaciones automáticas y devuelve la respuesta del usuario, una de otorgada, predeterminada, denegada
 */
function initializePushNotifications() {
  // request user grant to show notification
  return Notification.requestPermission((result) => {
    return result;
  });
}
/**
 * muestra una notificación
 */
function sendNotification() {
  const img = '';
  const text = 'Hay una novedad con tu vuelo hacia Nombre, Apellido';
  const title = 'Vuelo cancelado';
  const options = {
    body: text,
    icon: Logo,
    vibrate: [200, 100, 200],
    tag: 'flight-cancelled',
    image: img,
    badge: Logo,
    actions: [
      {
        action: 'Detail',
        title: 'Ver detalles',
        icon: '',
      },
    ],
  };
  navigator.serviceWorker.ready.then((serviceWorker) => {
    serviceWorker.showNotification(title, options);
  });
}

/**
 *
 */
function registerServiceWorker() {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/service-worker.js`)
    .then((swRegistration) => {
      // puedes hacer algo con el registro del trabajador del servicio (swRegistration)
    });
}

export {
  isPushNotificationSupported,
  initializePushNotifications,
  registerServiceWorker,
  sendNotification,
};
